
<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="车间余料汇总表"
      :page="page"
      :show-query="true"
      :get-data-func="api.vDetailSummary"
      v-if="trendShow"
      :reset-data-func="resetDataFunc"
      urlHash="business/stock/materialsummary"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/production/unBindMaterial").default,
      trendShow: true,
      tableData: [],
    };
  },
  methods: {
    resetDataFunc(data) {
      data.forEach((item, index) => {
        item.Sn = index + 1;
      });

      console.log("data", data);

      return data;
    },
  },
};
</script>

